import type { BucketPickerProps } from "./BucketPickerProps.js";

export const defaultBucketPickerProps: BucketPickerProps = {
  decay: 0.8,
  initial: 0.5,
};
